export { BottomBarItemPageEntityMobile } from './bottom-bar-item-page';
